import React from 'react';

import messages from './Messages';
import Modal from 'components/Modal';
import i18n from '../../i18n';

interface IComponentProps {
  reminderIndex: number;
  onReminderChange: (
    reminderIndex: number,
    inputType: 'reminder' | 'target' | 'timeTarget' | 'message',
    value: string
  ) => void;
  reminderValue: string;
}

interface IComponentStates {
  showModal: boolean;
  dateType: string;
  count: string;
}

const reminderOptions = {
  '-10080': i18n.t('oneWeekAgo', { ns: 'companyManagement' }),
  '-4320': i18n.t('threeDaysAgo', { ns: 'companyManagement' }),
  '-1440': i18n.t('oneDayAgo', { ns: 'companyManagement' }),
  '-60': i18n.t('oneHourAgo', { ns: 'companyManagement' }),
  '-30': i18n.t('halfHourAgo', { ns: 'companyManagement' }),
  '-15': i18n.t('quarterHourAgo', { ns: 'companyManagement' }),
  '60': i18n.t('oneHourLater', { ns: 'companyManagement' }),
  '1440': i18n.t('oneDayLater', { ns: 'companyManagement' }),
};

class Reminder extends React.PureComponent<IComponentProps, IComponentStates> {
  state: IComponentStates = {
    showModal: false,
    dateType: 'minute',
    count: '1',
  };

  handleChangeInput = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === 'reminder') {
      if (value === 'custom') {
        this.setState({ showModal: true });
      } else {
        this.props.onReminderChange(
          this.props.reminderIndex,
          'reminder',
          value
        );
      }
    } else if (name === 'dateType') {
      this.setState({ dateType: value });
    } else if (name === 'count') {
      this.setState({ count: value });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let min;
    const countNumber = Number(this.state.count);
    switch (this.state.dateType) {
      case 'minute':
        min = countNumber;
        break;
      case 'hour':
        min = countNumber * 60;
        break;
      case 'day':
        min = countNumber * 1440;
        break;
      case 'week':
        min = countNumber * 10080;
        break;
      default:
        min = 0;
    }
    this.props.onReminderChange(this.props.reminderIndex, 'reminder', min + '');
    this.handleCloseModal();
  };

  render() {
    const { reminderValue } = this.props;
    return (
      <React.Fragment>
        <Modal
          onClose={this.handleCloseModal}
          isActive={this.state.showModal}
          title={i18n.t('selectCustomTime', { ns: 'survey' })}
        >
          <div className="row">
            {
              i18n.t('negativeNumbersMeansAgoAndPositiveNumbersMeansLater', {
                ns: 'survey',
              }) as string
            }
          </div>
          <div className="row">
            <div className="col input-field">
              <input
                onChange={this.handleChangeInput}
                value={this.state.count}
                type="number"
                name="count"
                id="count"
              />
              <label htmlFor="count">
                {i18n.t('count', { ns: 'survey' }) as string}
              </label>
            </div>
            <div className="col">
              <label htmlFor="dateType">
                {i18n.t('type', { ns: 'survey' }) as string}
              </label>
              <select
                onChange={this.handleChangeInput}
                value={this.state.dateType}
                name="dateType"
                id="dateType"
                className="browser-default"
              >
                <option value="minute">
                  {i18n.t('minute', { ns: 'survey' }) as string}
                </option>
                <option value="hour">
                  {i18n.t('hour', { ns: 'survey' }) as string}
                </option>
                <option value="day">
                  {i18n.t('day', { ns: 'survey' }) as string}
                </option>
                <option value="week">
                  {i18n.t('week', { ns: 'survey' }) as string}
                </option>
              </select>
            </div>
          </div>
          <div className="row">
            <a
              onClick={this.handleSubmit}
              href="#!"
              className="btn waves-effect"
            >
              {i18n.t('confirm', { ns: 'survey' }) as string}
            </a>
          </div>
        </Modal>
        {
          <React.Fragment>
            <label htmlFor="offsetM">
              {i18n.t('reminderTime', { ns: 'survey' }) as string}
            </label>
            <select
              name="reminder"
              id="reminder"
              className="browser-default"
              onChange={this.handleChangeInput}
              value={reminderValue}
            >
              {Object.entries(reminderOptions).map((option, index) => (
                <option key={index} value={option[0]}>
                  {option[1]}
                </option>
              ))}
              {!Object.keys(reminderOptions).includes(reminderValue) && (
                <option value={reminderValue}>
                  {messages.makeReminderReadable(Number(reminderValue))}
                </option>
              )}
              <option value="custom">
                {i18n.t('custom', { ns: 'survey' }) as string}
              </option>
            </select>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Reminder;
